import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const MOCK_CREW = [
  { id: 'C-001', name: 'Ian Geerts', role: 'Owner', site: 'Kamsack Main', status: 'Full-time', phone: '(306) 590-8539', equipment: 'Oversight / All Units', hoursToday: 8.0, hoursWeek: 52.0, certifications: ['CDL-A', 'Applicator License', 'GPS Calibration'], notes: 'Owner/Operator, oversees all farm operations' },
  { id: 'C-002', name: 'Kyle Fehr', role: 'Operations Manager', site: 'Kamsack Main', status: 'Full-time', phone: '(306) 555-4412', equipment: 'NH T9.645 #2', hoursToday: 7.5, hoursWeek: 48.0, certifications: ['CDL-A', 'Precision Ag', 'CCA'], notes: 'Manages day-to-day operations across both sites' },
  { id: 'C-003', name: 'Travis Makuch', role: 'Lead Operator', site: 'Kamsack Main', status: 'Full-time', phone: '(306) 555-7831', equipment: 'NH T9.645 #1 + Bourgault 3420', hoursToday: 7.0, hoursWeek: 46.0, certifications: ['CDL-A', 'GPS Calibration', 'Precision Ag'], notes: 'Lead seeding operator, 10 years experience' },
  { id: 'C-004', name: 'Dylan Favel', role: 'Operator', site: 'Kamsack Main', status: 'Full-time', phone: '(306) 555-2198', equipment: 'NH SP.400F Sprayer', hoursToday: 6.5, hoursWeek: 42.0, certifications: ['CDL-A', 'Applicator License', 'Hazmat'], notes: 'Spray specialist, chemical mixing certified' },
  { id: 'C-005', name: 'Brett Olson', role: 'Operator', site: 'North Range', status: 'Full-time', phone: '(306) 555-6654', equipment: 'NH T8.435', hoursToday: 7.0, hoursWeek: 44.0, certifications: ['CDL-A', 'Precision Ag'], notes: 'Fertilizer and tillage specialist' },
  { id: 'C-006', name: 'Cody Fiddler', role: 'Operator', site: 'North Range', status: 'Full-time', phone: '(306) 555-3387', equipment: 'NH T7.315', hoursToday: 6.0, hoursWeek: 40.0, certifications: ['CDL-B', 'GPS Calibration'], notes: 'Harrowing and field prep operator' },
  { id: 'C-007', name: 'Austin Fehr', role: 'Mechanic', site: 'Kamsack Main', status: 'Full-time', phone: '(306) 555-9920', equipment: 'Shop / Field Service Truck', hoursToday: 8.0, hoursWeek: 45.0, certifications: ['ASE Diesel', 'Hydraulics Specialist', 'NH Certified Tech'], notes: 'Lead mechanic, New Holland dealer trained' },
  { id: 'C-008', name: 'Jake Fehr', role: 'Grain Cart / Logistics', site: 'Kamsack Main', status: 'Full-time', phone: '(306) 555-1145', equipment: 'NH T6.180 + Brent Cart', hoursToday: 5.0, hoursWeek: 38.0, certifications: ['CDL-A'], notes: 'Grain cart and transport logistics' },
  { id: 'C-009', name: 'Miranda Makuch', role: 'Office / Admin', site: 'Kamsack Main', status: 'Full-time', phone: '(306) 555-5502', equipment: 'N/A', hoursToday: 8.0, hoursWeek: 40.0, certifications: ['Bookkeeping', 'Payroll'], notes: 'Handles admin, payroll, and record keeping' },
  { id: 'C-010', name: 'Trevor Favel', role: 'Seasonal Operator', site: 'North Range', status: 'Seasonal', phone: '(306) 555-8876', equipment: 'NH CR10.90 #2 (harvest)', hoursToday: 0, hoursWeek: 24.0, certifications: ['CDL-B'], notes: 'Available for seeding and harvest seasons' },
  { id: 'C-011', name: 'Levi Fehr', role: 'Seasonal Operator', site: 'Kamsack Main', status: 'Seasonal', phone: '(306) 555-7743', equipment: 'Bourgault 3320-76 QDA', hoursToday: 6.0, hoursWeek: 30.0, certifications: ['CDL-B', 'GPS Calibration'], notes: 'Second season, training on combine' },
  { id: 'C-012', name: 'Morgan Fiddler', role: 'Seasonal Helper', site: 'North Range', status: 'Seasonal', phone: '(306) 555-4419', equipment: 'Utility / Grain Truck', hoursToday: 4.0, hoursWeek: 20.0, certifications: ['CDL-B'], notes: 'General helper, grain hauling and yard work' },
];

function CrewPage() {
  const [crew] = useState(MOCK_CREW);
  const [filterSite, setFilterSite] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => { /* Future: fetch from Supabase */ }, []);

  const getStatusBadge = (status) => {
    const map = { 'Full-time': 'badge-success', 'Seasonal': 'badge-warning' };
    return map[status] || 'badge-default';
  };

  const sites = ['all', ...new Set(crew.map(c => c.site))];
  const statuses = ['all', ...new Set(crew.map(c => c.status))];
  const filtered = crew.filter(c => {
    const matchSite = filterSite === 'all' || c.site === filterSite;
    const matchStatus = filterStatus === 'all' || c.status === filterStatus;
    return matchSite && matchStatus;
  });

  const fullTimeCount = crew.filter(c => c.status === 'Full-time').length;
  const seasonalCount = crew.filter(c => c.status === 'Seasonal').length;
  const operatorCount = crew.filter(c => c.role.includes('Operator') || c.role === 'Lead Operator').length;

  return (
    <div className="page-body">
      <div className="page-header">
        <div>
          <h1 style={{ margin: 0 }}>Crew</h1>
          <p style={{ margin: '4px 0 0', opacity: 0.7, fontSize: '0.85rem' }}>Geerts Farms Ltd. &mdash; {crew.length} personnel</p>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Total Crew</div>
          <div style={{ fontSize: '1.8rem', fontWeight: 700, color: '#0056A4' }}>{crew.length}</div>
        </div>
        <div className="stat-card">
          <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Full-time</div>
          <div style={{ fontSize: '1.8rem', fontWeight: 700, color: '#0056A4' }}>{fullTimeCount}</div>
        </div>
        <div className="stat-card">
          <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Seasonal</div>
          <div style={{ fontSize: '1.8rem', fontWeight: 700, color: '#FFD100' }}>{seasonalCount}</div>
        </div>
        <div className="stat-card">
          <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Operators</div>
          <div style={{ fontSize: '1.8rem', fontWeight: 700, color: '#0056A4' }}>{operatorCount}</div>
        </div>
      </div>

      {/* Filters */}
      <div style={{ display: "flex", gap: "12px", margin: "16px 0", flexWrap: "wrap", alignItems: 'center' }}>
        <span style={{ fontSize: '0.8rem', opacity: 0.6, textTransform: 'uppercase' }}>Site:</span>
        {sites.map(s => (
          <button key={s} className={filterSite === s ? "btn btn-primary" : "btn btn-secondary"} onClick={() => setFilterSite(s)} style={{ textTransform: "capitalize" }}>{s}</button>
        ))}
        <span style={{ borderLeft: '1px solid rgba(255,255,255,0.1)', margin: '0 4px' }} />
        <span style={{ fontSize: '0.8rem', opacity: 0.6, textTransform: 'uppercase' }}>Status:</span>
        {statuses.map(s => (
          <button key={s} className={filterStatus === s ? "btn btn-primary" : "btn btn-secondary"} onClick={() => setFilterStatus(s)} style={{ textTransform: "capitalize" }}>{s}</button>
        ))}
      </div>

      {/* Crew Table */}
      <div className="card" style={{ marginTop: '8px' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.1)", textAlign: "left" }}>
                <th style={{ padding: '10px 12px', fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Name</th>
                <th style={{ padding: '10px 12px', fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Role</th>
                <th style={{ padding: '10px 12px', fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Site</th>
                <th style={{ padding: '10px 12px', fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Status</th>
                <th style={{ padding: '10px 12px', fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Equipment</th>
                <th style={{ padding: '10px 12px', fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Hrs Today</th>
                <th style={{ padding: '10px 12px', fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Hrs/Week</th>
                <th style={{ padding: '10px 12px', fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Phone</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((m) => (
                <React.Fragment key={m.id}>
                  <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.05)", cursor: 'pointer' }} onClick={() => setExpandedId(expandedId === m.id ? null : m.id)}>
                    <td style={{ padding: '10px 12px', fontSize: '0.85rem', fontWeight: 600 }}>{m.name}</td>
                    <td style={{ padding: '10px 12px', fontSize: '0.85rem' }}>{m.role}</td>
                    <td style={{ padding: '10px 12px', fontSize: '0.85rem' }}>{m.site}</td>
                    <td style={{ padding: '10px 12px', fontSize: '0.85rem' }}><span className={getStatusBadge(m.status)}>{m.status}</span></td>
                    <td style={{ padding: '10px 12px', fontSize: '0.85rem' }}>{m.equipment}</td>
                    <td style={{ padding: '10px 12px', fontSize: '0.85rem' }}>{m.hoursToday} hrs</td>
                    <td style={{ padding: '10px 12px', fontSize: '0.85rem' }}>{m.hoursWeek} hrs</td>
                    <td style={{ padding: '10px 12px', fontSize: '0.85rem' }}>{m.phone}</td>
                  </tr>
                  {expandedId === m.id && (
                    <tr>
                      <td colSpan={8} style={{ padding: '12px 16px', background: 'var(--bg)' }}>
                        <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                          <div>
                            <strong style={{ fontSize: '0.8rem', opacity: 0.6 }}>Certifications:</strong>
                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '4px' }}>
                              {m.certifications.map(cert => (
                                <span key={cert} className="badge-default" style={{ fontSize: '0.75rem' }}>{cert}</span>
                              ))}
                            </div>
                          </div>
                          <div>
                            <strong style={{ fontSize: '0.8rem', opacity: 0.6 }}>Notes:</strong>
                            <div style={{ fontSize: '0.85rem', marginTop: '4px', opacity: 0.8 }}>{m.notes}</div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default CrewPage;
